module.exports = __webpack_public_path__ + "r-v3/img/mail.4a1cfe82.svg";